Vue.directive("focus", {
    inserted: function(el, binding) {
        if((binding.value && binding.expression) || ! binding.expression) {
            el.focus();
        }
    }
});